<template>
  <div class="product-card" :data-id="id" v-bind:class="{'product-card-grouped': isGrouped, 'product-card-show-more-deals': showMoreDeals}">
    <div class="product-image">
      <image-loader :src="bestDealsImage"></image-loader>
      <div class="gradient" @click="findSimilarProduct"></div>
      <div class="word-container white hd-18" @click="findSimilarProduct"><i class="far fa-search"></i>{{$t('web.travel-activities.show-similar-product')}}</div>
    </div>
    <div class="product-details">
      <div class="container-repsonsive">
        <div class="product-image-responsive">
          <image-loader :src="bestDealsImage"></image-loader>
        </div>
        <div class="word-container">
          <div class="product-name hm-16 hd-24 bold black">
            {{ name }}
          </div>
          <div class="product-description hd-14 gray700">
            {{ description }}
          </div>

        </div>
      </div>

      <div class="show-more-container">
        <div class="dropdown is-hoverable is-right show-more-container">
          <div class="dropdown-trigger">
            <a class="gray400"><i class="far fa-ellipsis-v"></i></a>
          </div>
          <div class="dropdown-menu" id="dropdown-menu4" role="menu">
            <div class="dropdown-content">
              <div>
                <a class="black hd-12" @click="findSimilarProduct"><i class="far fa-search"></i>{{ $t('web.travel-activities.show-similar-product')}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="meta-container" v-bind:class="{'product-card-with-no-rating': !ratings || ratings < 0}">
        <div class="price-container">
          <div class="rating-container" v-if="ratings && ratings > 0">
            <!--                        <div class="meta-title hm-14 hd-12">{{ $t('web.travel-activities.ratings') }}</div>-->
            <div class="meta-value hd-18"><img src="/images/rating-star.svg"> {{ ratings.toFixed(1) }}</div>
          </div>
          <div class="best-price">
            <!--                        <div class="meta-title hm-14 hd-12">{{ $t('web.travel-activities.best-deals') }}</div>-->
            <div class="meta-value provider-container">
              <div class="price hd-18">{{ priceCurrency }}{{ bestDealsPrice.toLocaleString() }}</div>
              <div class="provider-name hd-18 bold">{{ $t('web.travel-activities.provider-'+ bestDealsProvider )}}</div>
            </div>
          </div>
        </div>
        <div class="book-now-button">
          <div class="rating-container" v-if="ratings && ratings > 0">
            <div class="meta-value hd-18"><img src="/images/rating-star.svg"> {{ ratings.toFixed(1) }}</div>
          </div>

          <a :href="bestDealsUrl" target="_blank" class="button is-block is-success hd-14">{{ $t('web.travel-activities.book-now') }} <i class="far fa-chevron-right"></i></a>
        </div>
      </div>

      <div class="more-deals-container" v-if="isGrouped && showMoreDeals">
        <div class="rating-container" v-if="ratings && ratings > 0">
          <!--                    <div class="meta-title hm-14 hd-12">{{ $t('web.travel-activities.ratings') }}</div>-->
          <div class="meta-value hd-18 palette-yellow"><img src="/images/rating-star.svg"> {{ ratings.toFixed(1) }}</div>
        </div>
        <div class="meta-title hm-14 hd-12">{{ $t('web.travel-activities.offers')}}</div>
        <div class="providers-container">
          <div class="provider-container" v-for="activity in groupedActivitiesSorted">
            <div class="provider-name hd-18">
              <span>{{ $t('web.travel-activities.provider-' + activity.provider) }}</span>
            </div>
            <!--                        <img src="/images/provider-trip-logo.svg" v-if="activity.provider === 'hk.trip.com'" />-->
            <!--                        <img src="/images/provider-kkday-logo.svg" v-if="activity.provider === 'kkday.com'" />-->
            <!--                        <img src="/images/provider-klook-logo.svg" v-if="activity.provider === 'klook.com'" />-->
            <div class="price-container hd-18">
              <div v-if="activity.price > 0">{{ priceCurrency }}{{ activity.price.toLocaleString() }}</div>
              <div v-else>{{ $t('web.travel-activities.not-available') }}</div>
            </div>
            <div class="book-now-button hd-14">
              <a :href="activity.url" target="_blank" class="button is-block is-success hd-14">{{ $t('web.travel-activities.book-now') }} <i class="far fa-chevron-right"></i></a>
            </div>
          </div>
        </div>
      </div>

      <!--            <div class="more-deals-button-container" v-if="isGrouped">-->
      <!--                <a href="#" @click.prevent="showMoreDeals = true">{{ $t('web.travel-activities.more-deals') }} <i class="far fa-chevron-down"></i></a>-->
      <!--            </div>-->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    groupedActivities: Array,
    city: String,
    id: String,
    name: String,
    description: String,
    price: Number,
    priceCurrency: String,
    url: String,
    ratings: {
      type: Number,
      default: 0,
    }
  },

  data(){
    return {
      showMoreDeals: true,
      showMoreButton: false,
      c:"",
      q:"",
    }
  },

  computed: {
    isGrouped(){
      return true;
    },

    bestDealsActivity(){
      if(this.isGrouped){
        return this.groupedActivities.find(activity => activity.price === this.bestDealsPrice);
      }else{
        return null;
      }
    },

    bestDealsPrice(){
      if(this.isGrouped){
        let prices = this.groupedActivities.map(activity => activity.price);
        let minPrice = Math.min.apply(null, prices);
        return minPrice;
      }else{
        return this.price;
      }
    },

    bestDealsProvider(){
      if(this.isGrouped){
        return this.bestDealsActivity.provider;
      }else{
        return this.provider;
      }
    },

    bestDealsImage(){
      if(this.isGrouped){
        return this.bestDealsActivity.image;
      }else{
        return this.image;
      }
    },

    bestDealsUrl(){
      if(this.isGrouped){
        return this.bestDealsActivity.url;
      }else{
        return this.url;
      }
    },

    groupedActivitiesSorted() {
      const cannotBook = this.groupedActivities.filter(activity => activity.price === 0);
      const canBook = this.groupedActivities.filter(activity => activity.price > 0);
      return canBook.concat(cannotBook);
    },
  },

  methods: {
    findSimilarProduct(){
      this.q = this.name;
      const url = new URL(window.location.href = window.location.protocol + "//" + window.location.host + "/travel-activity/" + this.city);
      const paramString = new URLSearchParams();
      paramString.append("q", this.q);
      window.location.href = url + "?" + paramString.toString();
    },
  },

  mounted() {

  }
}
</script>

<style scoped lang="scss">
@import "../../sass/_mixin.scss";

.product-card{
  display: flex;
  margin-bottom: 16px;
  border-radius: 4px;
  border: 1px solid #D9DCDE;
  box-shadow: none;
  height: 260px;
  overflow: hidden;
  background: #FFF;
  &:hover{
    .product-image{
      .gradient {
        display: block;
        position: absolute;
        background: #070000;
        opacity: 0.3;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        cursor: pointer;

      }

      .word-container {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 100;
        cursor: pointer;
        .far {
          margin-right: 4px;
        }
      }
    }
  }

  @include responsive(){
    height: auto
  }

  .product-image{
    flex: 3;
    padding-top: 25%;
    position: relative;
    align-self: flex-start;
    overflow: hidden;

    @include responsive(){
      display: none;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      top: 0;
      left: 0;
    }
    .gradient{
      transition: background-color 0.3s ease-in-out;
    }
    .word-container{
      display: none;
    }
  }
  .product-details{
    position: relative;
    padding: 16px;
    flex: 5;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .container-repsonsive{
      @include responsive(){
        display: flex;
      }
    }

    .show-more-container{
      position: absolute;
      right: 8px;
      padding-left: 8px;
      @include responsive(){
      }
      .dropdown-menu{
        min-width: 8rem;
        text-align: center;
        .far{
          margin-right: 4px;
        }
      }
    }


    .product-image-responsive{
      display: none;

      @include responsive(){
        display: block;
        width: 30%;
        /*float: left;*/
        height: 30%;
        padding-top: 30%;
        position: relative;
        margin-right: 8px;

        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }

    .word-container{
      @include responsive(){
        width: calc(100% - 30%);
      }
      .product-name{
        margin-bottom: 8px;
        width: 95%;
      }

      .product-description{
        min-height: 63px;
        overflow: hidden;
        margin-bottom: 8px;
        text-overflow: ellipsis;
        white-space: inherit;
        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;

        @include responsive(){
          display: none;
        }
      }

    }

    .meta-title{
      text-transform: uppercase;
    }

    .meta-container{
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      width: 100%;
      /*bottom: 0;*/
      /*left: 0;*/
      /*position: absolute;*/
      /*padding: 16px;*/
      @include responsive(){
        /*margin-top: 24px;*/
      }

      .price-container{
        display: block;
        width: 100%;

        .rating-container{
          margin-right: 64px;
          @include responsive(){
            /*position: absolute;*/
            /*right: 16px;*/
            /*bottom: 68px;*/
            /*margin-right: 0;*/
            display: none;
          }
          img{
            width: 20px;
            position: relative;
            top: 2px;
          }

          .meta-value {
            color: #FEBC11;
            margin-top: 6px;
            /*display: flex;*/
          }
          .meta-title {
            @include responsive() {
              display: none;
            }
          }
        }

        .provider-container{
          display: flex;
          flex-direction: row-reverse;
          justify-content: space-between;
        }

        .price{
          color: #0176EE;
          font-weight: bold;
          margin-right: 16px;

          @include responsive(){
          }
        }

        .provider{
          color: #707070;
        }
      }

      .book-now-button{
        .rating-container{
          @include responsive(){
            text-align: end;
            padding-bottom: 8px;
          }
          .meta-value {
            color: #FEBC11;
            margin-top: 6px;
            display: none;
            @include responsive() {
              display: unset;
              margin-bottom: 8px;
            }

            img {
              width: 20px;
              position: relative;
              top: 2px;
            }
          }
          /*display: flex;*/
        }
        i{
          font-size: 12px;
          margin-left: 8px;
          position: relative;
          top: -1px;
        }

        @include responsive(){
          text-align: end;
          i{
            margin-left: 4px;
          }
        }
      }
    }

    .more-deals-button-container{
      position: absolute;
      bottom: 0;
      left: 0;
      text-align: center;
      width: 100%;
      padding: 4px;
      background: #F9F9F9;

      a{
        font-size: 12px;
        color: #333333;

        i{
          margin-left: 4px;
        }
      }
    }

    .more-deals-container{
      /*padding-top: 68px;*/

      .rating-container{
        .meta-title{
          @include responsive(){
            display: none;
          }
        }
        .meta-value{
          margin-top: 6px;
          img{
            width: 20px;
            position: relative;
            top: 2px;
          }
          @include responsive() {
            /*position: absolute;*/
            /*right: 16px;*/
            /*bottom: 115px;*/
            text-align: right;
          }
        }
      }

      .providers-container{
        .provider-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #D9DCDE;
          padding: 8px 0;

          &:last-child{
            border-bottom: none;
          }

          .provider-name{
            font-weight: bold;
            color: #333333;
          }

          .price-container{
            margin-left: auto;
            color: #0176EE;
            font-weight: bold;
            margin-right: 4px;
          }

          .book-now-button{
            margin-left: 16px;
          }
        }
      }
    }

  }
}

.product-card-grouped {
  height: auto;
  .meta-container {
    margin-bottom: 22px;
    display: none !important;

  }
}

.product-card-with-no-rating{
  @include responsive(){
    margin-top: 24px;
  }
}


.product-card-show-more-deals.product-card{
  /*height: auto;*/

  .more-deals-button-container,
  .meta-container{
    /*display: none;*/
  }
}
</style>
